import { useLazyQuery } from "@apollo/client/react";
import { useContext, useEffect } from "react";

import TemplateSelectContext from "../context/templateSelectContext";
import { GET_TEMPLATE_BY_UUID } from "../graphql/queries/GetTemplate";

interface UseApplyTemplateParams {
  noteUuid: string;
}

export function useApplyTemplate({
  noteUuid,
}: UseApplyTemplateParams) {
  const { selectedTemplateUuid, uuidOfNoteToOverwriteWithTemplate } =
    useContext(TemplateSelectContext) as {
      selectedTemplateUuid: string | null;
      uuidOfNoteToOverwriteWithTemplate: string | null;
    };

  const [getTemplate, { data }] = useLazyQuery(GET_TEMPLATE_BY_UUID, {
    fetchPolicy: "network-only",
  });

  const template = data?.template?.note;

  useEffect(() => {
    if (
      selectedTemplateUuid &&
      noteUuid === uuidOfNoteToOverwriteWithTemplate
    ) {
      getTemplate({
        variables: {
          uuid: selectedTemplateUuid,
        },
      });
    }
  }, [
    selectedTemplateUuid,
    getTemplate,
    noteUuid,
    uuidOfNoteToOverwriteWithTemplate,
  ]);

  return {
    template,
  };
}
